export const AUTOMATION_IDS = {
  NAME_LABEL: 'section-name-label',
  RENAME_BTN: 'section-rename-button',
};
